import {
  FETCH_FACILITY_ADMIN_LIST,
  FETCH_FACILITY_TAT_SETTING_LIST,
  FETCH_FACILITY_TEST_TYPE_BY_TEST_STATUS,
  FETCH_FACILITY_TEST_TYPE_COST_LIST,
  FETCH_FACILITY_TEST_TYPE_SERVICE_LIST,
  FETCH_GLOBAL_ADMIN_ANALYTICS,
  FETCH_GLOBAL_TAT_SETTING_LIST,
  FETCH_MACHINE_SETTINGS_LIST,
  FETCH_QUALITY_CONTROL_LIST,
  FETCH_TEST_TYPE_CONFIG_LIST,
  FETCH_TEST_TYPE_COST_LIST,
  FETCH_TEST_TYPE_SERVICE_LIST,
  FETCH_USER_LIST,
  FETCH_USER_LOCATION_LIST,
  FETCH_YES_NO_UNKNOWN_LIST,
  SET_ADMIN_USERS,
  SET_USER_LOCATION_PAGINATION,
} from "constants/ActionTypes";
import { pageSizeOptions } from "utils/Constant";

const INITIAL_STATE = {
  adminList: [],
  facilityAdminList: [],
  userLocationList: [],
  userLocationPagination: {
    count: 0,
    page: 1,
    page_size: pageSizeOptions[1],
    total_pages: 0,
    next: null,
    previous: null,
  },
  machineSettingsList: [],
  testTypeCostList: [],
  testTypeServiceList: [],
  globalTATList: [],
  facilityTATList: [],
  facilityTestTypeCostList: [],
  facilityTestTypeServiceList: [],
  facilityUserList: [],
  yesNoUnknownList: [],
  testTypeConfigList: [],
  qualityControlConfigList: [],
  globalAdminAnalytics: {},
  testTypeByStatus: [],
  loading: false,
};

const AdminReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SET_ADMIN_USERS: {
      return {
        ...state,
        adminList: payload,
      };
    }
    case FETCH_FACILITY_ADMIN_LIST: {
      return {
        ...state,
        facilityAdminList: payload,
      };
    }
    case FETCH_TEST_TYPE_CONFIG_LIST: {
      return {
        ...state,
        testTypeConfigList: payload,
      };
    }
    case FETCH_USER_LOCATION_LIST: {
      return {
        ...state,
        userLocationList: payload,
      };
    }
    case SET_USER_LOCATION_PAGINATION: {
      return {
        ...state,
        userLocationPagination: payload,
      };
    }
    case FETCH_MACHINE_SETTINGS_LIST: {
      return {
        ...state,
        machineSettingsList: payload,
      };
    }
    case FETCH_USER_LIST: {
      return {
        ...state,
        facilityUserList: payload,
      };
    }
    case FETCH_TEST_TYPE_COST_LIST: {
      return {
        ...state,
        testTypeCostList: payload,
      };
    }
    case FETCH_FACILITY_TEST_TYPE_COST_LIST: {
      return {
        ...state,
        facilityTestTypeCostList: payload,
      };
    }
    case FETCH_TEST_TYPE_SERVICE_LIST: {
      return {
        ...state,
        testTypeServiceList: payload,
      };
    }
    case FETCH_FACILITY_TEST_TYPE_SERVICE_LIST: {
      return {
        ...state,
        facilityTestTypeServiceList: payload,
      };
    }
    case FETCH_GLOBAL_TAT_SETTING_LIST: {
      return {
        ...state,
        globalTATList: payload,
      };
    }
    case FETCH_YES_NO_UNKNOWN_LIST: {
      return {
        ...state,
        yesNoUnknownList: payload,
      };
    }
    case FETCH_FACILITY_TAT_SETTING_LIST: {
      return {
        ...state,
        facilityTATList: payload,
      };
    }
    case FETCH_QUALITY_CONTROL_LIST: {
      return {
        ...state,
        qualityControlConfigList: payload,
      };
    }
    case FETCH_GLOBAL_ADMIN_ANALYTICS: {
      return {
        ...state,
        globalAdminAnalytics: payload,
      };
    }
    case FETCH_FACILITY_TEST_TYPE_BY_TEST_STATUS: {
      return {
        ...state,
        testTypeByStatus: payload,
      };
    }
    default:
      return state;
  }
};

export default AdminReducer;
